import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ADMIN_API_SERVER_URL } from '../tokens/admin-api-server-url.token';
import { ServerBaseService } from '../server-base.service';
import { BehaviorSubject, Observable, combineLatest, map } from 'rxjs';
import { UnitSize } from '@equipmyschool/emsadminweb-models';

@Injectable({
  providedIn: 'root'
})
export class UnitSizeService extends ServerBaseService {
  private _id$ = new BehaviorSubject<number>(null);
  private id$ = this._id$.asObservable();
  private _unitSizes$ = new BehaviorSubject<UnitSize[]>([]);
  
  public unitSizes$: Observable<UnitSize[]> = this._unitSizes$.asObservable();
  public UnitSize$: Observable<UnitSize> = combineLatest([this.unitSizes$, this.id$]).pipe(map(([unitSizes, id]) => unitSizes.find(UnitSize => UnitSize.UnitSizeID == id)));

  constructor(http: HttpClient, @Inject(ADMIN_API_SERVER_URL) serverUrl: string) {
    super(http, serverUrl)

    this.request<UnitSize[]>('GET', 'UnitSize/Get').subscribe({
      next: (unitSizes => this._unitSizes$.next(unitSizes))
    });
  }

  public getUnitSize(UnitSizeId: number) {
    this._id$.next(UnitSizeId);
  }
}
